<template>
  <div class="main">
    <div class="emphasis">
      <div>
        <img src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/common/logo.png" class="logo" alt="">
        <img src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/marketing/25.png" class="title" alt="">
        <div class="list">
          <div class="spot"></div>
          <div class="desc">《关于加强和改进中小学实验教学的意见》落地全国<span>30+</span>城市并逐步扩展</div>
        </div>
        <div class="list">
          <div class="spot"></div>
          <div class="desc">针对 <span>初中必做必考实验</span> 课程，全仿真模拟实验流程</div>
        </div>
        <div class="list">
          <div class="spot"></div>
          <div class="desc">支持 <span>反复练习</span> ，不受时间、空间、安全限制</div>
        </div>
        <div class="introduce">
          <video width="" height="" autoplay="autoplay" src="https://growlib-glp-u-resources.oss-cn-beijing.aliyuncs.com/res/40002/101/xQsGiwAW3c1616421852469.mp4" controls></video>
          <div class="desc">
            智慧宫是一款模拟物理、化学、生物实验场景，提供规范的实验内容、自由化交互的虚拟仿真实验室。
          </div>
        </div>
      </div>
      <img src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/marketing/26.png" class="backgroundImg" alt="">
    </div>
    <div class="classify">
      <div>
        <!-- 第一行 -->
        <div class="one">
          <div></div>
          <img src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/marketing/30.png" class="list" alt="">
          <img src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/marketing/31.png" class="list" alt="">
          <img src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/marketing/32.png" class="list" alt="">
          <img src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/marketing/33.png" class="list" alt="">
          <img src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/marketing/34.png" class="list" alt="">
          <img src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/marketing/35.png" class="list" alt="">
        </div>
        <!-- 第二行 -->
        <div class="two">
          <img src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/marketing/28.png" alt="">
          <div>
            <span>实验仪器准备、回收繁琐</span>
          </div>
          <div>
            <span>教学实验设备及</span>
            <span>耗材损耗成本高</span>
          </div>
          <div>
            <span>实验探究难度大，</span>
            <span>某一环节出问题即失败，教学效率低</span>
          </div>
          <div>
            <span>直接接触实验用品，</span>
            <span>部分实验课程危险性高</span>
          </div>
          <div>
            <span>教学过程细节操作</span>
            <span>监控难</span>
          </div>
          <div>
            <span>需在教学实验室</span>
            <span>完成实验课程</span>
          </div>
        </div>
        <!-- 第三行 -->
        <div class="three">
          <img src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/marketing/29.png" alt="">
          <div>
            <span>利用理想化虚拟环境，避免现实因素影响</span>
          </div>
          <div>
            <span>无需昂贵的实验设备及</span>
            <span>耗材，虚拟课程内容</span>
            <span>可反复使用</span>
          </div>
          <div>
            <span>碎片化实验内容，</span>
            <span>保证学生自由探索</span>
            <span>可<span>反复操作</span>练习，</span>
            <span>高效教学</span>
          </div>
          <div>
            <span>纯虚拟实验模型教学</span>
            <span><span>0距离0事故</span></span>
          </div>
          <div>
            <span>学生实验过程<span>数据化展现</span></span>
            <span>提升教师授课效</span>
          </div>
          <div>
            <span>灵活方便，</span>
            <span>随时随地开展教学</span>
          </div>
        </div>
      </div>
    </div>
    <div class="site">
      <img src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/marketing/36.png" class="title" alt="">
      <img src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/marketing/37.png" class="content" alt="">
    </div>
    <div class="advantage">
      <img src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/marketing/13.png" alt="" class="title">
      <div class="list">提供“智能化硬件+常态化应用+数字化内容+数据化服务”解决方案，全方位为教育变革深度赋能。</div>
      <div class="list"> <span>100+VR</span> 软件著作权</div>
      <div class="list"> <span>20+</span> 行业发明专利</div>
      <div class="list">5G教育云平台教学内容总保有量全球领先</div>
      <div class="list"> <span>1000+</span> 项目落地，覆盖 <span>全球10多个国家</span> </div>
      <div class="more" @click="go">
        <span>了解更多方案</span>
        <img src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/marketing/14.png" alt="">
      </div>
    </div>
    <div class="footer">
      <div>
        <img src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/common/two.jpg" alt="">
        <div class="desc">
          <div>官方热线：</div>
          <div>400-888-1126</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  created() {
 
  },
  mounted() {
 
  },
  methods: {
    go(){
      window.scrollTo(0, 0)
      this.$router.push({
        name: 'wisdom'
      })
    }
  }
};
</script>
<style lang="less" scoped>
.main {
  background: #fff;
  .emphasis{
    width: 100%;
    min-height: 1120px;
    position: relative;
    overflow: hidden;
    > div{
      width: 1200px;
      margin: 0 auto;
      position: relative;
      z-index: 2;
      .logo{
        width: 110px;
        display: block;
        margin-top: 40px;
      }
      .title{
        width: 768px;
        margin-top: 80px;
        margin-bottom: 44px;
      }
      .list{
        display: flex;
        align-items: center;
        margin-top: 22px;
        .spot{
          width: 12px;
          height: 12px;
          background: #000000;
          border-radius: 2px;
          opacity: 0.5;
        }
        .desc{
          width: 835px;
          margin-left: 12px;
          font-size: 24px;
          font-weight: 400;
          color: #000000;
          line-height: 42px;
          span{
            font-size: 32px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #FF7211;
            line-height: 42px;
            margin-top: 22px;
          }
        }
      }
      .introduce{
        width: 100%;
        height: 386px;
        margin: 0 auto;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 30px;
        video{
          width: 631px;
          height: 386px;
        }
        .desc{
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 24px;
          width: 533px;
          height: 100%;
          padding-left: 30px;
          font-weight: 400;
          color: #000000;
          line-height: 50px;
          background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 100%);
        }
      }
    }
    .backgroundImg{
      position: absolute;
      top: 0;
      right: 0;
      z-index: 1;
      width: 1300px;
      opacity: 0.6;
    }
  }
  .classify{
    width: 100%;
    height: 506px;
    background: #F6F6F6;
    > div{
      width: 1200px;
      height: 100%;
      margin: 0 auto;
      padding-top: 1px;
      .one{
        width: 100%;
        display: flex;
        margin-top: 45px;
        > div{
          width: 59px;
          height: 61px;
        }
        img{
          width: 190px;
          height: 61px;
        }
      }
      .two, .three{
        width: 100%;
        display: flex;
        img{
          width: 59px;
          height: 175px;
        }
        > div{
          width: 190px;
          height: 175px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          // padding: 0 10px;
          > span{
            font-size: 16px;
            font-weight: 400;
            color: #000000;
            line-height: 22px;
            display: block;
            text-align: center;
            span{
              font-size: 16px;
              font-weight: 400;
              line-height: 22px;
              color: #FF7211;
            }
          }
          border-bottom: 2px solid #fff;
        }
        > div:nth-child(2n-1){
          background: #fff;
        }
        > div:nth-child(2n){
          background: #F0EFEF;
        }
      }
      .three > div{
        border-bottom: none;
      }
    }
  }
  .site{
    width: 100%;
    height: 614px;
    .title{
      display: block;
      width: 253px;
      margin: 0 auto;
      margin-top: 35px;
    }
    .content{
      display: block;
      width: 1200px;
      margin: 0 auto;
      margin-top: 25px;
    }
  }
  .advantage{
    width: 100%;
    padding-top: 1px;
    display: flex;
    align-items: center;
    flex-direction: column;
    background: #F6F6F6;
    > img{
      display: block;
      width: 222px;
      margin: 0 auto;
      margin-top: 32px;
      margin-bottom: 32px;
    }
    .list{
      font-size: 26px;
      font-weight: 600;
      color: #000000;
      line-height: 50px;
      margin-bottom: 39px;
      span{
        font-size: 26px;
        font-weight: 500;
        color: #F27D2C;
        line-height: 22px;
      }
    }
    .more{
      display: flex;
      align-items: center;
      cursor: pointer;
      margin-top: 48px;
      margin-bottom: 60px;
      span{
        font-size: 26px;
        font-weight: 400;
        color: #7E92B5;
        line-height: 50px;
      }
      img{
        width: 23px;
        margin-left: 10px;
      }
    }
  }
  .footer{
    width: 100%;
    height: 267px;
    background: #0B0114;
    padding-top: 1px;
    > div{
      width: 1200px;
      height: auto;
      margin: 0 auto;
      display: flex;
      align-items: center;
      margin-top: 46px;
      > img{
        width: 175px;
        margin-right: 20px;
      }
      .desc{
        div:nth-child(1){
          font-size: 18px;
          font-weight: 500;
          color: #FFFFFF;
          line-height: 27px;
          margin-top: 27px;
        }
        div:nth-child(2){
          font-size: 36px;
          font-weight: bold;
          color: #FFFFFF;
          line-height: 54px;
        }
      }
    }
  }
}
</style>
